<template>
  <article class="row mx-0">
    <b-card
      v-for="(plan, index) in subscriptionPlans"
      :key="index"
      class="col-md-3 col-xs-6 col-xxs-12 px-0 mb-3"
      bg-variant="white"
      :footer="$t('UserProfile.Subscription.BuySubscriptionFactor.Subscribe')"
      footer-class="text-center cursor-pointer"
      :footer-text-variant="plan.TextAccent.toLowerCase()"
      :footer-bg-variant="plan.Accent.toLowerCase()"
      body-class="text-center justify-content-start align-items-center d-flex flex-md-column flex-xxs-row p-0 cursor-pointer"
      @click="SelectPlan(plan)"
    >
      <div :class="'bg-' + plan.Accent.toLowerCase()" class="m-3 p-1 rounded-circle plan-icon" >
        <img :src="plan.Icon" height="100" width="100" class="m-4">
      </div>
      <div class="d-flex flex-column align-items-center w-100 px-1">
        <h4 class="my-3" :class="'text-' + plan.TextAccent.toLowerCase()" v-html="plan.Title" />
        <small
          v-if="plan.Discount"
          :class="'text-' + plan.TextAccent.toLowerCase()"
          v-html="'<del class=\'text-muted\'>'+plan.Price +' '+ plan.Unit+'</del>'"
        />
        <h6
          v-else
          :class="'text-' + plan.TextAccent.toLowerCase()"
          v-html="plan.Price +' '+ plan.Unit"
        />
        <h6
          v-if="plan.Discount"
          class="d-flex text-danger text-center my-3"
          v-html="plan.Discount+'%'"
        />
        <h5
          v-if="plan.Discount"
          :class="'text-' + plan.TextAccent.toLowerCase()"
          v-html="plan.DiscountedPrice + ' ' + plan.Unit"
        />
        <p
          v-if="plan.Description"
          :class="{'my-2': !plan.Discount}"
          class="d-flex text-dark text-align-start px-3"
        >
          <small v-html="plan.Description" />
        </p>
      </div>
    </b-card>
  </article>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserProfileNewUserSubscriptions',
  props: {
    subscriptionPlans: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      Payment: 'order/payment'
    })
  },
  methods: {
    SelectPlan (selectedPlan) {
      this.IsPlanTypeDaily(selectedPlan) ? this.$router.push({ path: 'vasSubscription' }) : this.$emit('SelectPlan', selectedPlan)
    },
    IsPlanTypeDaily (selectedPlan) {
      return selectedPlan.Type == 'Daily'
    }
  }
}
</script>
